module.exports = __webpack_public_path__ + "static/media/female-hairs.11f6339a.svg";